// Fonte: UManutContas.pas — b7Click ~linha 9089, MemoObservacao → tabela Observacao
// Permissões: ManutencaoObservacoes (23) para CRUD, ConsultaObservacoes (24) para leitura
// Modelo: 1 registro por conta (Codigo_Conta + codigo_grupo_empresa = PK composta)
import React, { useState, useEffect, useCallback } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  listarObservacoesConta,
  salvarObservacaoConta,
  excluirObservacaoConta,
} from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';

var TabObservacoes = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;

  var podeEditar = AuthStorage.temCaracteristica(caracteristicas.ManutencaoObservacoes);
  var podeVer = podeEditar || AuthStorage.temCaracteristica(caracteristicas.ConsultaObservacoes);

  var [textoObs, setTextoObs] = useState('');
  var [textoOriginal, setTextoOriginal] = useState('');
  var [loading, setLoading] = useState(false);
  var [salvando, setSalvando] = useState(false);
  var [possuiRegistro, setPossuiRegistro] = useState(false);

  var carregar = useCallback(function() {
    if (!ge || !codigo || !podeVer) return;
    setLoading(true);
    listarObservacoesConta(ge, codigo)
      .then(function(resp) {
        var obs = resp && resp.obs ? resp.obs : '';
        setTextoObs(obs);
        setTextoOriginal(obs);
        setPossuiRegistro(!!resp && resp.obs !== null && resp.obs !== undefined);
      })
      .catch(function() { toast.error('Erro ao carregar observações'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo, podeVer]);

  useEffect(function() { carregar(); }, [carregar]);

  if (!podeVer) {
    return (
      <div className="contas-tab-content text-center text-muted py-3">
        Sem permissão para consultar observações.
      </div>
    );
  }

  var alterado = textoObs !== textoOriginal;

  var handleSalvar = function() {
    if (!textoObs) { toast.warning('Informe a observação'); return; }
    setSalvando(true);
    salvarObservacaoConta(ge, codigo, { obs: textoObs })
      .then(function() {
        toast.success('Observação salva!');
        setTextoOriginal(textoObs);
        setPossuiRegistro(true);
      })
      .catch(function() { toast.error('Erro ao salvar observação'); })
      .finally(function() { setSalvando(false); });
  };

  var handleExcluir = function() {
    if (!possuiRegistro) return;
    excluirObservacaoConta(ge, codigo)
      .then(function() {
        toast.success('Observação excluída!');
        setTextoObs('');
        setTextoOriginal('');
        setPossuiRegistro(false);
      })
      .catch(function() { toast.error('Erro ao excluir observação'); });
  };

  var handleCancelar = function() {
    setTextoObs(textoOriginal);
  };

  return (
    <div className="contas-tab-content">
      {loading ? (
        <div className="text-center py-3"><Spinner animation="border" /></div>
      ) : (
        <React.Fragment>
          <Form.Control
            as="textarea"
            rows={6}
            value={textoObs}
            onChange={function(e) { setTextoObs(e.target.value); }}
            placeholder="Texto da observação..."
            disabled={!podeEditar}
          />
          {podeEditar && (
            <div className="d-flex justify-content-end mt-2">
              {possuiRegistro && (
                <Button size="sm" variant="outline-danger" className="mr-2" onClick={handleExcluir}>
                  Excluir
                </Button>
              )}
              {alterado && (
                <Button size="sm" variant="outline-secondary" className="mr-2" onClick={handleCancelar}>
                  Cancelar
                </Button>
              )}
              <Button size="sm" variant="success" onClick={handleSalvar} disabled={salvando || !alterado}>
                {salvando ? <Spinner animation="border" size="sm" /> : 'Gravar'}
              </Button>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

export default TabObservacoes;
